import {FC, useContext} from 'react';
import TGButton from 'src/components/ui/TGButton';
import ModalResultPassingTest from './ModalResultPassingTest';

import {PassingTestContext} from './passingTestContext';

interface IProps {
  countCorrectAnswers: number;
}
const PassingTestFooter: FC<IProps> = ({countCorrectAnswers}) => {
  const {showResultsTest, startPassingTest} = useContext(PassingTestContext);

  return (
    <footer className="pb-10 flex justify-between">
      <TGButton type="button" color="white" onClick={startPassingTest}>
        Назад
      </TGButton>

      {!showResultsTest && <ModalResultPassingTest countRightAnswers={countCorrectAnswers} />}
    </footer>
  );
};
export default PassingTestFooter;
